import type { ComponentMultiStyleConfig } from "@chakra-ui/react"

// dist/css/table.css, compact density (ADR 0001: the simple variant is the compact table):
// 40px rows, 13px text, 11px uppercase headers on surface-alt.
export const Table: ComponentMultiStyleConfig = {
  parts: ["table", "thead", "tbody", "tr", "th", "td", "caption"],
  variants: {
    simple: {
      table: {
        fontSize: "xs",
      },
      th: {
        fontFamily: "body",
        fontSize: "3xs",
        fontWeight: "semibold",
        letterSpacing: "wider",
        textTransform: "uppercase",
        color: "textMuted",
        bg: "surfaceAlt",
        px: 3,
        py: 2,
        borderBottom: "1px solid",
        borderColor: "lineStrong",
      },
      td: {
        h: "rowHCompact",
        px: 3,
        py: 0,
        borderBottom: "1px solid",
        borderColor: "line",
      },
      tbody: {
        tr: {
          _hover: {
            bg: "surfaceAlt",
          },
          "&[data-selected='true']": {
            bg: "surfaceGreige",
          },
        },
      },
      caption: {
        fontSize: "2xs",
        letterSpacing: "widest",
        textTransform: "uppercase",
        color: "textMuted",
      },
    },
  },
}
